// =============================================================================
// React Entry Point
// =============================================================================

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import './styles/global.css';

// =============================================================================
// Render Application
// =============================================================================

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

// Determine base path from the current URL or default to /superadmin
const getBasename = (): string => {
  // In production, the UI is served at /superadmin
  // In development (vite dev), it's served at /
  const pathname = window.location.pathname;
  if (pathname.startsWith('/superadmin')) {
    return '/superadmin';
  }
  return '/';
};

root.render(
  <StrictMode>
    <BrowserRouter basename={getBasename()}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
